"use strict";
/**
 * After a rotation, an iOS home-screen app can be left with the document scrolled (by about the
 * status bar's height) while still painted in place, so taps land above the finger until the next
 * scroll (N3 PLAN A211). The document never scrolls in this app (each `.page` does), so after an
 * orientation change it is put back at the origin. Only on orientation changes: a keyboard's resize
 * legitimately scrolls the document to keep its field in view.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SETTLE_MS = void 0;
exports.installRotationScrollReset = installRotationScrollReset;
/** iOS applies the rotation's offset late; checked again until it has settled. */
exports.SETTLE_MS = [0, 100, 300, 700];
const NO_KEYBOARD = new Set(["button", "checkbox", "radio", "submit", "reset", "range", "color", "file", "image", "hidden"]);
/** A field the operator is typing in, with the keyboard up: its scroll is iOS keeping it in view. */
function typingInVisibleField(doc) {
    const el = doc.activeElement;
    if (!el || el === doc.body)
        return false;
    const editable = el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement || el.isContentEditable
        || (el instanceof HTMLInputElement && !NO_KEYBOARD.has(el.type));
    return editable && el.getClientRects().length > 0; // a hidden page's field can keep focus
}
function resetIfOffset(win) {
    if (typingInVisibleField(win.document))
        return;
    const offsetTop = win.visualViewport?.offsetTop ?? 0;
    if (win.scrollX !== 0 || win.scrollY !== 0 || offsetTop !== 0)
        win.scrollTo(0, 0);
}
/** Returns its uninstall, for tests. */
function installRotationScrollReset(win = window) {
    const query = win.matchMedia?.("(orientation: portrait)");
    if (!query)
        return () => { };
    let timers = [];
    const clear = () => {
        timers.forEach((t) => win.clearTimeout(t));
        timers = [];
    };
    const onChange = () => {
        clear(); // a quick turn back starts the checks over
        timers = exports.SETTLE_MS.map((ms) => win.setTimeout(() => resetIfOffset(win), ms));
    };
    query.addEventListener("change", onChange);
    return () => {
        query.removeEventListener("change", onChange);
        clear();
    };
}
